module.exports = __webpack_public_path__ + "img/Aya Madi.bbfa8c25.jpg";